// 📁 src/components/InputWrapper.jsx
// Última edición: 2025-07-08 23:28 PM - Añadida la prop isProcessing para deshabilitar input y botón.

import React, { useRef, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const InputWrapper = ({
  inputMessage,
  setInputMessage,
  handleSendMessage,
  selectedAssistant,
  selectedChatId,
  sidebarVisible, // Esta prop no se usa directamente en InputWrapper, pero se mantiene si es necesaria para otros propósitos.
  showInputArea, // Esta prop no se usa directamente en InputWrapper, pero se mantiene si es necesaria para otros propósitos.
  isProcessing // ✅ AÑADIDA: Prop para indicar si hay una operación en curso
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [inputMessage]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      // Solo permite enviar si no está en procesamiento
      if (!isProcessing) { // ✅ AÑADIDA: Verificación de isProcessing antes de enviar
        handleSendMessage();
        textareaRef.current?.blur();
      }
    }
  };

  const getAssistantAccentColor = () => {
    const assistantColors = {
      pminovel: 'bg-pminovel-accent',
      pmifast: 'bg-pmifast-accent',
      crisis: 'bg-red-600',
      comunica: 'bg-green-600'
    };
    return assistantColors[selectedAssistant] || 'bg-blue-500';
  };

  // ✅ MODIFICADA: La condición para deshabilitar el botón ahora incluye isProcessing
  const isSendButtonDisabled = inputMessage.trim() === '' || !selectedChatId || isProcessing;

  return (
    <div className="w-full px-3 md:px-4 pt-3 md:pt-2 pb-2 md:pb-1 bg-white border-t mt-2">
      <div className="relative w-full max-w-3xl mx-auto flex items-end bg-white border-2 border-gray-300 rounded-2xl shadow-lg overflow-hidden min-h-[3.5rem] md:min-h-[4rem]">
        <textarea
          ref={textareaRef}
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Escribe tu mensaje..."
          inputMode="text"
          autoComplete="off"
          autoCorrect="off"
          spellCheck={false}
          rows={1}
          className="flex-1 resize-none overflow-hidden p-4 md:p-4 text-base md:text-gray-800 focus:outline-none placeholder-gray-500 min-h-[3.5rem] md:min-h-[3rem] max-h-[8rem] leading-relaxed"
          style={{ fontSize: '16px' }} // Prevents zoom on iOS
          disabled={isProcessing}
        ></textarea>
        <button
          onClick={handleSendMessage}
          disabled={isSendButtonDisabled}
          className={`
            p-3 md:p-3 m-2 rounded-full flex-shrink-0 min-h-[44px] min-w-[44px] flex items-center justify-center
            ${getAssistantAccentColor()} text-white shadow-lg
            transition-all duration-150 ease-in-out
            ${isSendButtonDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105 active:scale-95 hover:shadow-xl'}
          `}
        >
          <ArrowUp size={18} />
        </button>
      </div>
      
      {/* Indicador de procesamiento móvil */}
      {isProcessing && (
        <div className="flex items-center justify-center mt-2 md:hidden">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <div className="w-4 h-4 border-2 border-gray-400 border-t-blue-600 rounded-full animate-spin"></div>
            <span>Escribiendo respuesta...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default InputWrapper;